import script from "./TutorialSpotlight.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialSpotlight.vue?vue&type=script&setup=true&lang=js"

import "./TutorialSpotlight.vue?vue&type=style&index=0&id=a796dee4&scoped=true&lang=css"
import "./TutorialSpotlight.vue?vue&type=style&index=1&id=a796dee4&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a796dee4"]])

export default __exports__